import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { SplashScreen } from '@capacitor/splash-screen';
import { App } from '@capacitor/app';

export function initMobile() {
  if (!Capacitor.isNativePlatform()) return;

  // Match status bar to cream header background.
  StatusBar.setStyle({ style: Style.Light });
  StatusBar.setBackgroundColor({ color: '#f7f3eb' });

  // Hide splash after first meaningful paint — called from main.tsx after render.
  SplashScreen.hide({ fadeOutDuration: 300 });

  // Android hardware back button: navigate back or exit the app.
  App.addListener('backButton', ({ canGoBack }) => {
    if (canGoBack) {
      window.history.back();
    } else {
      App.exitApp();
    }
  });
}
